import LoanAmortizationCalculator from './LoanAmortizationCalculator';

export default LoanAmortizationCalculator;
